/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createClusterDetailsHeaderStyles = makeStyles(theme => ({
  panel: {
    padding: '20px 24px',
    borderRadius: '12px',
    backgroundColor: '#F6F7F8',
    marginBottom: '30px',
  },
  panelTitle: {
    color: theme.palette.primary.main,
    padding: 0,
    fontSize: '28px',
    lineHeight: ' 28px',
    fontWeight: 700,
    letterSpacing: '-0.5px',
  },
  panelEditWrapper: {
    display: 'inline-flex',
    paddingTop: '3px',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  panelActionsWrapper: {
    paddingTop: '3px',
    display: 'inline-flex',
    height: 'fit-content',
  },
  panelStatusWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: '-3px',
    height: 'fit-content',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
  },
  chipStatus: {
    marginLeft: '20px',
    fontFamily: 'monospace',
  },
  subHeader: {
    fontSize: '14px',
    lineHeight: '14px',
  },
  subHeaderWrapper: {
    marginTop: '16px',
    width: 'auto',
  },
  subHeaderItem: {
    padding: '0 8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  subHeaderValue: {
    fontWeight: 700,
    textAlign: 'center',
  },
  subHeaderLabel: {
    textAlign: 'center',
    color: '#909196',
    padding: '0 8px',
    fontSize: '12px',
  },
  divider: {
    background: '#DCDEE1',
  },
  clusterName: {
    textTransform: 'none',
  },
  addressContainer: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  address: {
    display: 'inline-flex',
    backgroundColor: 'rgba(162,167,174, .1)',
    padding: '8px 10px',
    borderRadius: '3px',
    color: '#000000',
    fontFamily: 'Apercu Mono',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.09px',
  },
  raiseRequestIcon: {
    marginLeft: '8px',
    transform: 'scale(1.5)',
    padding: '0',
  },
  editIconWrapper: {
    marginLeft: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  editIcon: {
    width: '24px',
    height: '24px',
    padding: '0',
  },
  bottomOffset: {
    marginBottom: '20px',
  },
  editLocationIcon: {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
  },
}));
